import { MenuItem, Select } from '@mui/material';
import React from 'react';

import FormattedMessages from '../../../messages/RootComponentsFormattedMessages';

const YesNoSelect = ({
  name,
  value = '',
  error,
  isInvalid,
  onChange,
  size = 'small',
  required = false,
  helperText = '',
  useBoolean = false,
}) => {
  const handleChange = (event) => {
    if (useBoolean) {
      onChange(event, event.target.value === 'Y');
    } else {
      onChange(event, event.target.value);
    }
  };

  return (
    <Select
      name={name}
      value={
        useBoolean && typeof value === 'boolean' ? (value ? 'Y' : 'N') : value
      }
      onChange={handleChange}
      size={size}
      error={isInvalid || !!error}
      required={required}
      helpertext={error || helperText || ''}
      fullWidth
    >
      <MenuItem value="Y">{FormattedMessages.yes}</MenuItem>
      <MenuItem value="N">{FormattedMessages.no}</MenuItem>
    </Select>
  );
};

export default YesNoSelect;
